module.exports = __webpack_public_path__ + "static/img/kols3.e050130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols3.png
// module id = 7ZLL
// module chunks = 0